import { useNavigate } from 'react-router-dom';
import { getClientAwarePath } from '@api/http.api.ts';
import serviceUnavailableImg from '@assets/status-pages/service_unavailable.webp';
import { SERVICE_UNAVAILABLE_STATUS_CODE } from '@constants/api.ts';
import { useAppSelector } from '@hooks/reduxHooks.ts';
import { useLingui } from '@lingui/react/macro';
import { ROUTES } from '@router/constants.ts';
import { getUserPreferencesOrDefaults } from '@routes/___shared___/utils.ts';
import { isTokenValid } from '@routes/auth/___shared___/helpers.ts';
import StatusPage from '@routes/system/___shared___/components/status-page';
import { Text } from '@routes/system/___shared___/components/status-page/styled.tsx';
import { getPreferredStartPage, readToken } from '@store/services/localStorage.service.ts';
import { formatDateTimeBasedOnPreferences } from '@utils/date.ts';

const ServiceUnavailable = () => {
    const { t } = useLingui();
    const userFullInfo = useAppSelector((state) => state.user.userInfo);
    const userPreferencesSettings = getUserPreferencesOrDefaults(userFullInfo);
    const { preferredDateFormat: dateFormat, preferredTimeFormat: timeFormat } = userPreferencesSettings;
    const maintenanceInfo = useAppSelector((state) => state.health.healthStatus?.maintenanceInfo);
    const expectedEndOfMaintenanceUTC = maintenanceInfo?.expectedEndOfMaintenanceUTC;
    const isMaintenance = maintenanceInfo?.isMaintenance;
    const navigate = useNavigate();

    const formattedMaintenanceEndDate = formatDateTimeBasedOnPreferences(
        expectedEndOfMaintenanceUTC || '',
        dateFormat,
        timeFormat,
    );

    if (isMaintenance === false) {
        const token = readToken();

        if (isTokenValid(token)) {
            const target = getPreferredStartPage() || ROUTES.SIDEBAR.LEARNING;
            navigate(getClientAwarePath(target), { replace: true });
        } else {
            navigate(getClientAwarePath(ROUTES.AUTH.LOGIN), { replace: true });
        }
    }

    return (
        <StatusPage
            image={<img src={serviceUnavailableImg} alt={t`service unavailable image`} />}
            header={String(SERVICE_UNAVAILABLE_STATUS_CODE)}
            subheader={t`Service Unavailable`}
            content={
                <Text>
                    {t`Sorry, we're busy improving your experience.`}
                    <br />
                    {t`Please come back later.`}
                    <br />
                    <br />
                    {t`Expected completion time of maintenance`}: {formattedMaintenanceEndDate}
                </Text>
            }
            useCallbackUrlForBackButton
            fetchClientData={false}
        />
    );
};

export default ServiceUnavailable;
